 <template>
  <div id="listfournisseur" class="data-list-container">
   <h1 class="content-center">a faire</h1>
  </div>
</template>
 

<script>
import index from "@/http/requests/admin/index.js";
import pdf from "vue-pdf";

export default {
  data() {
    return {
      activeConfirm: false,
      selectedClient: null,
      baseUrl: "",
      shadowpdf: false,
      currentPage: 1,
      cellAutoWidth: true,
      headerTitle: [
        "N° Client",
        "Nom",
        "Email",
        "Telephone",
        "Adresse",
        "Magazin"
      ],
      headerVal: ["No", "Name", "Email", "Phone_No", "Adress", "Location_code"]
    };
  },
  computed: {
    usersData() {
      return this.$store.state.moduleusermanagement.listClient.value;
      //  return this.$store.state.moduleusermanagement.listFournisseur.value;
    },

    paginationPageSize() {
      return 20;
    },
    totalPages() {
      if (this.$store.state.moduleusermanagement.listClient.value)
        return this.$store.state.moduleusermanagement.listClient.value.length;
      else return 0;
    }
  },
  methods: {
    onClientSelect(selected) {
      console.log(selected);

      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: `Ajouter Client Portail `,
        text: "Voulez vous ajout " + this.selectedClient.Name + " au utilisateurs de portail.",
        acceptText: "Ajouter",
        accept: this.addClient
      });
    },
    addClient() {
      console.log(this.selectedClient);
      index
        .addClientToPort(this.selectedClient)
        .then(data => {
          console.log(data);
        })
        .catch(err => {
          console.log(err);
        });
    },

    exportToExcel() {
      import("@/vendor/Export2Excel").then(excel => {
        console.log(this.dataList);
        const data = this.formatJson(this.headerVal, this.dataList);
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: "xlsx"
        });
        //this.clearFields()
      });
    },
    exportToCsv() {
      import("@/vendor/Export2Excel").then(excel => {
        console.log(this.dataList);
        const data = this.formatJson(this.headerVal, this.dataList);
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: "csv"
        });
        //this.clearFields()
      });
    },
    exportToTxt() {
      import("@/vendor/Export2Excel").then(excel => {
        console.log(this.dataList);
        const data = this.formatJson(this.headerVal, this.dataList);
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: "txt"
        });
        //this.clearFields()
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          // Add col name which needs to be translated
          // if (j === 'timestamp') {
          //   return parseTime(v[j])
          // } else {
          //   return v[j]
          // }

          return v[j];
        })
      );
    },
    clearFields() {
      (this.filename = ""),
        (this.cellAutoWidth = true),
        (this.selectedFormat = "xlsx");
    }
  },
  mounted() {},
  components: {
    pdf
  }
};
</script>

 
<style lang="scss">
#listfournisseur {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000000;

  .vs-table {
    border-collapse: separate;
    // border-spacing: 0 1.3rem;
    padding: 0 1rem;

    tr {
      box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.05);

      td {
        // align-items: center;
        // justify-content: center;
        // text-align: center;
        vertical-align: middle;

        &:first-child {
          border-top-left-radius: 0.5rem;
          border-bottom-left-radius: 0.5rem;
        }

        &:last-child {
          border-top-right-radius: 0.5rem;
          border-bottom-right-radius: 0.5rem;
        }

        &.img-container {
          span {
            display: flex;
            justify-content: flex-start;
          }

          .product-img {
            height: 110px;
          }
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 5;
        padding-bottom: 5;
        color: "primary";
        background: #002b5c;
        justify-content: center;

        .vs-table-text {
          //text-transform: uppercase;
          font-weight: 600;
          color: white;
          justify-content: center;
        }
      }
    }
  }

  @media (max-width: 461px) {
    .items-per-page-handler {
      display: none;
    }
  }

  @media (max-width: 341px) {
    .data-list-btn-container {
      width: 100%;

      .dd-actions,
      .btn-add-new {
        width: 100%;
        margin-right: 0 !important;
      }
    }
  }

  .product-name {
    max-width: 23rem;
  }

  .vs-table--header {
    display: flex;
    flex-wrap: wrap;
    margin-left: 1.5rem;
    margin-right: 1.5rem;

    > span {
      display: flex;
      flex-grow: 1;
    }

    .vs-table--search {
      padding-top: 0;

      .vs-table--search-input {
        padding: 0.9rem 2.5rem;
        font-size: 1rem;

        & + i {
          left: 1rem;
        }

        &:focus + i {
          left: 1rem;
        }
      }
    }
  }
}
</style>

